import { get } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Returns the chat session object
 * @param {Number} chatSessionId Chat session ID
 * @returns object
 */
export function useChatSession(chatSessionId) {
    const selectorFunction = useMemo(() => {
        return (state) => get(state, `chat.indexed[${chatSessionId}]`);
    }, [chatSessionId]);

    return useSelector(selectorFunction) ?? null;
}
